// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { StringSegment, IStringSegment } from "./Microsoft.Extensions.Primitives.StringSegment.gen";

export interface IEntityTagHeaderValue {
	tag: IStringSegment | undefined;

	isWeak: boolean;

	$type?: string | undefined;
}
export class EntityTagHeaderValue {
	constructor(data?: IEntityTagHeaderValue) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.tag) { this.tag = new StringSegment(data.tag); }
	}

	tag: StringSegment | undefined;

	isWeak: boolean = false;

	static $type: string = "Microsoft.Net.Http.Headers.EntityTagHeaderValue, ";
	$type?: string | undefined = EntityTagHeaderValue.$type;
}

